import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbClientsEvents } from '@irb-common/events';
import { ImportExternalAccountsResultGridLayoutService } from '@irb/irb-clients/import-external-accounts-result-dialog/import-external-accounts-result.grid-layout.service';
import { IAccount, IExternalAccounts, IExternalAccountInvalidRecord, IRestoreExternalAccountRecord } from '@irb/irb-clients/irb-clients.model';

@Component({ standalone: false,
  selector: 'irb-import-external-accounts-result-dialog',
  templateUrl: './import-external-accounts-result-dialog.component.html',
  styleUrls: ['./import-external-accounts-result-dialog.component.scss', '../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportExternalAccountsResultDialogComponent implements OnInit {
  grid: any;
  gridDeletedExtAccts: any;
  gridOptions: any;
  gridOptionsDeletedExtAccts: any;
  invalidAndOverriddenRecords: Array<IExternalAccountInvalidRecord> = [];
  deletedExtAccts: Array<IExternalAccountInvalidRecord> = [];
  warn_main: string;
  hasValidRecords: boolean = false;
  needsAdditionalAction: boolean = false;
  additionActionCount: number = 0;
  disableContinueBtn:boolean = true;
  frameworkComponents: any;
  parent_deletedExtAccts: any = {
    enableDisableBtns: () => {  
      const count = (this.gridDeletedExtAccts && this.gridDeletedExtAccts.api && this.gridDeletedExtAccts.api.getSelectedRows) ? this.gridDeletedExtAccts.api.getSelectedRows().length : 0;
      this.disableContinueBtn = count ? false : true;
    },
    totalRecordsFromServer: 0,
    uniqueField: "accountNumber",
    deselectedFromSelectAllRecords: []
  };

  constructor(
    public dialogRef: MatDialogRef<ImportExternalAccountsResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IExternalAccounts,
    public as: AppService,
    private gls: ImportExternalAccountsResultGridLayoutService
  ) {
    this.combineInvalidAndOverridenRecords();
    this.removeInvalidDeletedRecords();
    this.validate();

    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this },
      suppressHorizontalScroll: true
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();

    this.gridOptionsDeletedExtAccts = {
      columnDefs: this.gls.getColumnDefsWithSelectAll(this.parent_deletedExtAccts),
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this },
      rowSelection: 'multiple',
      suppressHorizontalScroll: true
    };
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
    //this.grid.api.sizeColumnsToFit();
  }

  onGridOptionsDeletedExtAcctsReady(params: any) {
    this.gridDeletedExtAccts = params;
    //this.gridDeletedExtAccts.api.sizeColumnsToFit();
    this.parent_deletedExtAccts.enableDisableBtns();
  }

  completeImport() {
    this.data.validRecordsList = [].concat(this.data.validRecords);
    this.data.restoreAcctList = [];

    if(this.data.deletedExtAccts.length > 0) {
      // if the user has chosen not to restore them, remove deleted accounts from valid list
      if (this.gridDeletedExtAccts && this.gridDeletedExtAccts.api) {
        this.gridDeletedExtAccts.api.forEachNode((n: any) => {
          if (!n.isSelected()) {
            for (let i = 0; i < this.data.validRecordsList.length; i++) {
              if (this.data.validRecordsList[i].object[0] === n.data.accountNumber) {
                this.data.validRecordsList.splice(i--, 1);
              }
            }
          } else {
            const a = this.data.deletedExtAccts.find((x: IAccount) => x.accountNumber === n.data.accountNumber) || {};
            this.data.restoreAcctList.push({
              "accountName": a.accountName || "",
              "accountNumber": a.accountNumber,
              "masterNumber": a.masterNumber,
              "portfolioId": a.portfolioId || "",
              "accountId": a.accountId
            } as IRestoreExternalAccountRecord);
          }
        });
      }
    }

    this.as.fireEvent(IrbClientsEvents.IMPORT_EXTERNAL_ACCOUNTS_VALIDATE, this.data);
    this.close();
  }

  combineInvalidAndOverridenRecords() {
    this.invalidAndOverriddenRecords = [];

    this.data.invalidRecords.forEach((r: IExternalAccountInvalidRecord) => {
      this.invalidAndOverriddenRecords.push({
        accountNumber: r.accountNumber,
        errorDesc: r.errorDesc + ", line " + r.lineNumber
      } as IExternalAccountInvalidRecord);
    });

    this.data.overrideExtAccts.forEach((r: string) => {
      this.invalidAndOverriddenRecords.push({
        accountNumber: r,
        errorDesc: "Duplicate account number"
      } as IExternalAccountInvalidRecord);
    });
  }

  removeInvalidDeletedRecords() {
    //remove deleted accounts if they're not present in valid list
    for (let i = 0; i < this.data.deletedExtAccts.length; i++) {
      let isValid = false;

      for (let ii = 0; ii < this.data.validRecords.length; ii++) {
        if (this.data.validRecords[ii].object[0] === this.data.deletedExtAccts[i].accountNumber) {
          isValid = true;
          break;
        }
      }

      if (!isValid) {
        this.data.deletedExtAccts.splice(i--, 1);
      }
    }

    this.data.deletedExtAccts.forEach((r: IAccount) => {
      this.deletedExtAccts.push({
        accountNumber: r.accountNumber,
        errorDesc: "Deleted account"
      } as IExternalAccountInvalidRecord);
    });

    this.parent_deletedExtAccts.totalRecordsFromServer = this.deletedExtAccts.length;
  }

  validate() {
    this.hasValidRecords = (this.data.validRecords.length - this.data.deletedExtAccts.length) > 0;
    this.needsAdditionalAction = (this.data.deletedExtAccts.length > 0 || this.data.overrideExtAccts.length > 0);
    this.additionActionCount = this.data.deletedExtAccts.length + this.data.overrideExtAccts.length;

    if (this.data.invalidAccountCount > 0) {
      this.warn_main = this.data.invalidAccountCount + " external accounts of " + this.data.totalCount + " in your file cannot be imported.";
    } else {
      this.warn_main = "Additional action needed.";
    }
  }
}
